import { resourceExplorerProviderByProviderPossibleFiltersSelector } from "../resourceExplorerProviderByProviderPossibleFiltersSelector";
import { RootState } from "../../../../../store";

export const azurePossibleFiltersSelector = (state: RootState) => {
  return resourceExplorerProviderByProviderPossibleFiltersSelector({
    provider: "azure",
  })(state)?.data;
};
